/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Draft
 * 
 * 1 = Created
 * 
 * 2 = Rejected
 * 
 * 3 = PendingApproval
 * 
 * 4 = Approved
 * 
 * 5 = Ordered
 * 
 * 6 = Picking
 * 
 * 7 = InProduction
 * 
 * 8 = Dispatched
 * 
 * 9 = PartialReceived
 * 
 * 10 = Received
 * 
 * 11 = Complete
 * 
 * 12 = AwaitingCustomerApproval
 */
export enum PurchaseOrderStatus {
  Draft = 0,
  Created = 1,
  Rejected = 2,
  PendingApproval = 3,
  Approved = 4,
  Ordered = 5,
  Picking = 6,
  InProduction = 7,
  Dispatched = 8,
  PartialReceived = 9,
  Received = 10,
  Complete = 11,
  AwaitingCustomerApproval = 12
}
